let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1643713410039x328501505113980900',
    },
    {
        id: 2,
        trackTitle: "Entry-level",
        trackSubtitle: "For Junior specialists",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Entry-level',
        trackLink: 'https://geekle.us/ticketfree/1643713517140x221484033332477950',
    },
  ];
  
  export default PackagesItem;
  